<div class="spinner-overlay" *ngIf="spinnerService.spinner$ | async">
  <div class="flex flex-column align-items-center">
    <div class="logo-container">
      <img src="assets/logo/PNG/simbolo/amareloLogo.png" alt="Logo" class="logo">
    </div>
    <p class="text-white mt-3 text-lg">{{ spinnerService.message$ | async }}</p>
  </div>
</div>
